import { gql } from '@apollo/client';

export const GET_ONBOARDING_STATE = gql`
  query GetOnboardingState {
    getOnboardingState {
      isNew
      currentStep
      completedSteps
      billingPlan
    }
  }
`;
